(function( $ ) {
  // $('*[data-background]').each(function(){
  //   let background = $(this).data('background');
  //   $(this).css('background', background);
  // });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partial/backgrounds.js